module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_c('i', [_vm._v("Twitter")])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_c('b', [_vm._v("Twitter Name")]), _vm._v(" @TiwtterHandle")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_c('b', [_vm._v("Twitter Name")]), _vm._v(" @TiwtterHandle")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "img h2"
  })])])]), _vm._v(" "), _c('section', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('i', [_c('b', [_vm._v("Twitter Name")]), _vm._v(" @TiwtterHandle")]), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "col-12"
  }, [_vm._v("\n        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet,\n        consectetur adipiscing elit. Aenean euismod bibendum laoreet.Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n        Aenean euismod bibendum laoreet.\n        "), _c('br'), _c('br'), _vm._v(" "), _c('a', [_vm._v("http://www.grc.org/programs.aspx?id=16786")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ca30492"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/publications/article-detail/MediaTwitterPage.vue
// module id = 1399
// module chunks = 1